module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/surgicals/yaji_d-7169519626e7551a18fba56faf92e9ee.png";